import React, { useEffect, useRef } from 'react'
import './style.css'
import '../../assets/animations/generalAnimations.css'
import MainBanner from '../../components/specific/mainbanner/MainBanner';
import TopBar from '../../components/general/topbar/TopBar';
import Footer from '../../components/general/footer/Footer'
import Utilitario from '../../assets/images/banners/webps/Utilitario.webp'
import Aires from '../../assets/images/banners/webps/Aires.webp'
import KitAires from '../../assets/images/banners/webps/kitAire.webp'
import ButtonMinimalist from '../../components/general/button/ButtonMinimalist';
import IGLogo from '../../assets/images/social/instagram-round2.webp'
import FBLogo from '../../assets/images/social/facebook-round2.webp'
import WPLogo from '../../assets/images/social/whatsapp2.webp'
import DG from '../../assets/datosGenerales.json'
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Banner from '../../assets/images/banners/webps/Iveco.webp'

export default function Home() {

  let m1 = useRef(), m2 = useRef(), m3 = useRef();
  let navigate = useNavigate();

  useEffect(() => {
    const observerM1 = new IntersectionObserver(entries => {
      entries.forEach(entry => { 
        if(entry.isIntersecting){ 
          m1.current.style.animation = "fadeIn 1.2s linear 1"; 
          m1.current.style.opacity = "1"; 
          observerM1.unobserve(m1.current) 
        }
      })
    })

    const observerM2 = new IntersectionObserver(entries => {
      entries.forEach(entry => { 
        if(entry.isIntersecting){ 
          m2.current.style.animation = "fadeIn 1.2s linear 1";
          m2.current.style.opacity = "1";
          observerM2.unobserve(m2.current) 
        }
      })
    })

    const observerM3 = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          m3.current.style.animation = "fadeIn 1.2s linear 1"; 
          m3.current.style.opacity = "1"; 
          observerM3.unobserve(m3.current) 
        }
      })
    })

    observerM1.observe(m1.current)
    observerM2.observe(m2.current)
    observerM3.observe(m3.current)

    window.scroll(0, 0)
  })

  const metaTags = {
    title: "Inicio",
    description: "Nicolini Refrigeración es un empresa dedicada a la venta, instalación y reparación de equipos de frío para camiones y utilitarios. Además cuenta con venta de insumos y repuestos para refrigeracion familiar, comercial y del automotor",
    url: "https://www.nicolinirefrigeracion.com.ar/"
  }

  return (
    <div className='Home'>
      <h1>Nicolini Refrigeración</h1>

      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" 
        content={metaTags.description} />

        <meta property="og:site_name" content="Nicolini Refrigeracíon" />
        <meta name='title' property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={Banner} />
        <meta property="og:url" content={metaTags.url} />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content={metaTags.title} />
        <meta name="twitter:description" content={metaTags.description} />
        <meta name="twitter:image" content={Banner} />
      </Helmet>

      <TopBar />
      <MainBanner />
      <div className='pageDisplay' id='m1'>
        <div className="h_menu" ref={m1}>
          <img src={Utilitario} alt='Iveco Daily'/>
          <div>
            <h2 className='title'>Equipos para vehículos</h2>
            <p className='text'>{"Instalación de equipos de frío para transporte de cargas refrigeradas"}</p>
          </div>
          <ButtonMinimalist text={"Ir a Transporte"} onClick={() => navigate("productos/transporte")} />
        </div>
        <div className="h_menu" ref={m2}>
          <img src={KitAires} alt='Kit de materiales para instalación de aire acondicionado'/>
          <div>
            <h2 className='title'>Repuestos e insumos</h2>
            <p className='text'>{"Todo en refrigeración familiar y comercial lo encontrás aquí"}</p>
          </div>
          <ButtonMinimalist text={"Ir a Insumos"} onClick={() => navigate("productos/insumos")} />
        </div>
        <div className='h_menu' ref={m3}>
          <img src={Aires} alt='Aire acondicionado'/>
          <div>
            <h2 className='title'>Equipos de Aire Acondicionado</h2>
            <p className='text'>{"Asesoramiento de acuerdo a sus necesidades. Líneas residenciales y comerciales. Variedad de marcas. Recibimos aquí su consulta."}</p>
          </div>
          <ButtonMinimalist text={"Ir a Aires"} onClick={() => navigate("productos/aires")} />
        </div>
      </div>

      <div className='pageDisplay' id='m2'>
        <div id="div1">
            <h2 className='title'>¿Que hay de nuevo?</h2>
            <p className='text'>{"Enterate de todas nuestras novedades a través de nuestras redes"}</p>
            <div className='icon-gallery'>
              <a href={DG.linkInstagram} target="_blank" rel='noreferrer' title='Instagram'><img className='icon' src={IGLogo} alt='Instagram'/></a>
              <a href={DG.linkFacebook} target="_blank" rel='noreferrer' title='Facebook'><img className='icon' src={FBLogo} alt='Facebook'/></a>
              <a href={DG.linkWhatsApp} target="_blank" rel='noreferrer' title='WhatsApp'><img className='icon' src={WPLogo} alt='WhatsApp'/></a>
            </div>
          </div>
          <iframe className='socialMediaFrame' scrolling='no' src='https://www.instagram.com/nicolinirefrigeracionoficial/embed' title='Feed de Instagram de Nicolini Refrigeración'></iframe>
      </div>

      <div className='pageDisplay' id='m3'>
        <div id="div1">
            <h2 className='title'>¿Sos técnico en refrigeración?</h2>
            <p className='text'>{"Sumate a nuestra comunidad de técnicos y acccedé a los beneficios que tenemos para vos"}</p>
        </div>
        <div id="div2">
          <a className='title' href='register'>Registrarse</a>
        </div>
      </div>
      <Footer />
    </div>
  )
}